/* eslint-disable react-hooks/exhaustive-deps */
import { Checkbox, TableRow, TableCell, Flex } from '@tonic-one/react';
import {
  AccountData,
  AppData,
  SaModalState,
  SelectedRow,
  Token,
} from './types';
import React, { useEffect, useState } from 'react';
import { AdministrationApi } from '@Apis';
import { useTranslation } from 'react-i18next';
import SATableStatus from './SATableStatus';
import { AppForSa } from '@Types/administrator';
import { TokenStatus } from '@Types/provision';
import { useUtcOffsetStore } from '../../../models/useUtcOffsetModel';
import { getUtcTime } from '../../../utils/time';
import SATableEmail from './SATableEmail';
import { PermissionNameEnum } from '@Types/permissions';
import { usePermissionStore } from '@Models/usePermissionModel';

export default function SingleOrgTable({
  account,
  selectedRow,
  setSelectedRow,
  setSaModalState,
}: {
  account: AccountData;
  selectedRow: SelectedRow | null;
  setSelectedRow: (v: SelectedRow | null) => void;
  setSaModalState: (v: SaModalState) => void;
}) {
  const { t } = useTranslation();
  const { orgId, orgName, apps } = account;
  const [tokenStatusMap, setTokenStatusMap] = useState<
    Record<string, Token | undefined>
  >({});
  const fetchTokenStatus = async () => {
    let data: {
      app: AppForSa;
      appId: string;
      tokenStatus: TokenStatus;
      appOwner: number;
      [key: string]: any;
    }[] = [];
    try {
      data = (await AdministrationApi.apiGetTokenStatus(orgId)).data;
    } catch {
      throw new Error('apiGetTokenStatus error');
    }
    const tokens: Record<string, Token> = {};
    for (const item of data) {
      tokens[item.app] = {
        tokenStatus: item.tokenStatus,
        appId: item.appId,
        appOwner: item.appOwner, //it seems just for teams chat
        tokenTypes: item.tokenTypes,
      };
    }
    setTokenStatusMap(tokens);
  };

  useEffect(() => {
    fetchTokenStatus().catch((e) => {
      console.error(e);
    });
    return () => {
      setTokenStatusMap({});
    };
  }, []);
  const { widthEditablePermission } = usePermissionStore();
  return (
    <>
      <OrgNameRow orgId={orgId} orgName={orgName} />
      {apps.map((appData) => {
        if (
          t(`common.service.${appData.app}`) === `common.service.${appData.app}`
        ) {
          return <></>;
        }
        return (
          <AppRow
            key={`${orgId}_${appData.app}`}
            orgId={orgId}
            appData={appData}
            token={
              tokenStatusMap[appData.app] || {
                appId: '',
                tokenStatus: TokenStatus.NotStarted,
                appOwner: 0,
                tokenTypes: [],
              }
            }
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            setSaModalState={
              !widthEditablePermission(PermissionNameEnum.administrator)
                ? () => {
                    return;
                  }
                : setSaModalState
            }
          />
        );
      })}
    </>
  );
}
// export default React.memo(SingleOrgTable, (pre, next) => {
//   if (
//     pre.account.orgId === next.account.orgId &&
//     pre.account.apps.length === next.account.apps.length &&
//     pre.selectedRow?.orgId === pre.account.orgId &&
//     next.selectedRow?.orgId === next.account.orgId
//   ) {
//     return true;
//   }

//   return false;
// });

const OrgNameRow = ({ orgId, orgName }: { orgId: string; orgName: string }) => {
  return (
    <TableRow key={orgId} width="100%">
      <TableCell width="100%" fontWeight={600}>
        {orgName}
      </TableCell>
      <TableCell width="0" />
      <TableCell width="0" />
      <TableCell width="0" />
      <TableCell width="0" />
    </TableRow>
  );
};

const AppRow = ({
  orgId,
  appData,
  token,
  selectedRow,
  setSelectedRow,
  setSaModalState,
}: {
  orgId: string;
  appData: AppData;
  token: Token;
  selectedRow: SelectedRow | null;
  setSelectedRow: (v: SelectedRow | null) => void;
  setSaModalState: (v: SaModalState) => void;
}) => {
  const { t } = useTranslation();
  const { offset } = useUtcOffsetStore();
  const checked = selectedRow
    ? selectedRow.orgId === orgId && selectedRow.app === appData.app
    : false;

  return (
    <TableRow width="100%">
      <TableCell width="32px" display="inline-flex" alignItems="center">
        <Checkbox
          checked={checked}
          onChange={() =>
            setSelectedRow(checked ? null : { orgId, app: appData.app })
          }
        />
      </TableCell>
      <TableCell
        width="40%"
        flexGrow="2"
        display="inline-flex"
        alignItems="center"
      >
        <Flex alignItems="center" maxWidth="400px">
          <SATableEmail appData={appData} token={token} />
        </Flex>
      </TableCell>
      <TableCell
        width="15%"
        flexGrow="1"
        display="inline-flex"
        alignItems="center"
      >
        {/* TODO: RMS 暂时忽略 */}
        {/* if (typeof service_types[data] == "undefined" && data == "rms") {
        return '<span>{{"HTML_PAGE.administration.office365_credentials.RMS" | i18n  }}</span> <img ps-popover style="margin-top:-3px;" src="/images/messageIcon_info.png" data-toggle="tooltip" data-content="{{\'HTML_PAGE.administration.office365_credentials.RMS_TIP\'|i18n}}">';
      } */}
        {appData.app ? t(`common.service.${appData.app}`, appData.app) : ''}
      </TableCell>
      <TableCell
        width="15%"
        flexGrow="1"
        display="inline-flex"
        alignItems="center"
      >
        {!appData.endDate || appData.endDate === 'N/A'
          ? 'N/A'
          : getUtcTime(appData.endDate, offset, t('common.momentDateFormat'))}
        {/* getUtcTime(app.endDate, timeZone, t('common.momentDateFormat')) */}
      </TableCell>
      <TableCell
        width="30%"
        flexGrow="2"
        display="inline-flex"
        alignItems="center"
      >
        <SATableStatus
          orgId={orgId}
          setSaModalState={setSaModalState}
          data={{ ...appData, ...token }}
        />
      </TableCell>
    </TableRow>
  );
};
